import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {getTeacherTools} from "./__graphql-types__/getTeacherTools.ts";
import type {localesForTeacherToolsBanner} from "./__graphql-types__/localesForTeacherToolsBanner.ts";

export const TEACHER_TOOLS_FETCH: GqlOperation<getTeacherTools> = gqlOp(gql`
    query getTeacherTools {
        aiGuideTeacherTools(order: TEACHER_TOOLS_PAGE) {
            id
            configName
        }
    }
`);

export const TEACHER_TOOLS_LOCALE_BANNER_QUERY: GqlOperation<localesForTeacherToolsBanner> =
    gqlOp(gql`
        query localesForTeacherToolsBanner {
            localesForLanguagePicker(
                includeEnglish: false
                includeFake: false
            ) {
                id
                localName
                kaLocale
            }
        }
    `);
